import script from "./personal-finance.vue?vue&type=script&setup=true&lang=js"
export * from "./personal-finance.vue?vue&type=script&setup=true&lang=js"

import "./personal-finance.vue?vue&type=style&index=0&id=58e9067a&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./personal-finance.vue?vue&type=style&index=1&id=58e9067a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e9067a"]])

export default __exports__